export function reorderFavouriteIds(current, orderedIds) {
  const favourites = Array.isArray(current) ? current : [];
  const selected = new Set(orderedIds);
  const present = new Set(favourites);
  return [
    ...orderedIds.filter((id) => present.has(id)),
    ...favourites.filter((id) => !selected.has(id)),
  ];
}
